export const BOOK_MEETING_URLS = {
  ['Thomas Bay Pedersen']:
    'https://meetings-eu1.hubspot.com/thomas-bay1/upgrade',
  ['Anders Winther']: 'https://meetings-eu1.hubspot.com/anders-winther/upgrade',
  ['Claus Kelm-Nielsen']:
    'https://www.cyberpilot.io/meetings/claus-kelm-nielsen/upgrade',
  ['Jan Kehlet Schou']:
    'https://meetings-eu1.hubspot.com/jan-kehlet-schou/upgrade',
  ['Jesper Korsgaard']:
    'https://meetings-eu1.hubspot.com/jesper-korsgaard/upgrade',
  ['Lene Kragelund']: 'https://meetings-eu1.hubspot.com/lene-kragelund/upgrade',
  ['Troels Jakobsen']:
    'https://meetings-eu1.hubspot.com/troels-jakobsen/upgrade',
  ['Astrid Møller Lauritsen']:
    'https://meetings-eu1.hubspot.com/astrid-lauritsen/upgrade',
  ['Espen Lien']: 'https://meetings-eu1.hubspot.com/espen-lien/upgrade',
  ['Jonas Kaasa']: 'https://meetings-eu1.hubspot.com/jka/upgrade',
  ['Tobias Kjær Eriksen']:
    'https://meetings-eu1.hubspot.com/tobias-kjaer-eriksen/upgrade',
};
